import { render, staticRenderFns } from "./TechnicalFeaturesPerformance.vue?vue&type=template&id=2f3ba36c"
import script from "./TechnicalFeaturesPerformance.vue?vue&type=script&lang=js"
export * from "./TechnicalFeaturesPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports